import React, { useEffect, createElement } from 'react';
const JOTFORM_ID = '261584122801148';
export function FinalCTA() {
  useEffect(() => {
    // Load JotForm's official responsive feedback script once.
    const SCRIPT_SRC = 'https://form.jotform.com/static/feedback2.js';
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return <section id="contact" className="py-24 px-6 md:px-12 bg-white relative overflow-visible scroll-mt-24" data-id="element-25">
      {/* Decorative background element */}
      <div className="absolute bottom-0 left-0 w-full h-1/2 bg-cream -z-10" data-id="element-26"></div>

      <div className="max-w-5xl mx-auto bg-navy rounded-3xl shadow-2xl overflow-visible" data-id="element-27">
        <div className="grid grid-cols-1 md:grid-cols-2 items-start" data-id="element-28">
          <div className="p-10 md:p-16 flex flex-col justify-center" data-id="element-29">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-30">
              Interested in One of These Boats?
            </h2>
            <p className="text-navy-200 text-lg mb-8 leading-relaxed" data-id="element-31">
              Inventory changes quickly throughout the season. Contact us today
              to request pricing, availability, or additional photos.
            </p>
            <div data-id="element-32">
              <div className="flex items-center gap-4 text-white" data-id="element-33">
                <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center" data-id="element-34">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-copper" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-35">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" data-id="element-36" />
                  </svg>
                </div>
                <div data-id="element-37">
                  <p className="text-sm text-navy-300" data-id="element-38">Call Us</p>
                  <p className="font-heading font-semibold text-xl" data-id="element-39">
                    (518) 555-0198
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 md:p-12" data-id="element-40">
            <div className="w-full" data-id="element-41">
              <iframe id={`JotFormIFrame-${JOTFORM_ID}`} title="Contact form" src={`https://form.jotform.com/${JOTFORM_ID}`} width="100%" height="660" frameBorder={0} scrolling="yes" className="border-0 rounded-lg block" data-id="element-42" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}